import React from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  Row,
  Col,
  Label,
  ModalHeader,
  FormGroup,
  ModalFooter,
} from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import "flatpickr/dist/themes/material_blue.css";
import CustomSelect from "../../../../../../components/Common/CustomSelect";
import { showInfoMessage } from "../../../../../../helpers/utils";

const LegalEntityModal = props => {
  const {
    isOpen,
    toggle,
    userId,
    editData,
    permissions,
    options,
    updateBankDetails,
    bankDetails,
  } = props;
  const [selectedEntity, setSelectedEntity] = React.useState();

  React.useEffect(() => {
    if (editData !== null && isOpen) {
      setSelectedEntity(editData);
    } else {
      setSelectedEntity("");
    }
  }, [isOpen]);

  const onSubmitForm = (e, errors, params) => {
    if (errors?.length === 0) {
      let currentData = {
        ...params,
        default_legal_entity: params.default_legal_entity.value,
      };
      if (Object.keys(bankDetails).length === 0) {
        showInfoMessage("First you need to add a bank information");
      } else {
        props.updateBankDetails(bankDetails.id, currentData, bankDetails.user);
        toggle();
      }
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      autoFocus={true}
      centered={true}
      toggle={toggle}
      size="sx"
    >
      <div className="modal-header">
        <h4 className="modal-title mt-0" id="myModalLabel">
          {editData !== null ? "Edit" : "Add"} default legal entity
        </h4>
        <button
          type="button"
          onClick={toggle}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <AvForm className="needs-validation" onSubmit={onSubmitForm}>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup className="mb-3">
                <Label htmlFor="">Default legal entity:</Label>
                <CustomSelect
                  name={"default_legal_entity"}
                  defaultValue={selectedEntity}
                  options={
                    options.map(i => {
                      return {
                        label: i.counterparty_name,
                        value: i.id,
                      };
                    }) || []
                  }
                  placeholder="Select default legal entity..."
                  classNamePrefix="select2-selection"
                  errorMessage="Legal entity is required!"
                  required
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                {permissions?.["change_bankdetailsmodel"] && (
                  <button
                    type="submit"
                    className="btn btn-success save-user ms-2"
                  >
                    Save changes
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

LegalEntityModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  editData: PropTypes.object,
  data: PropTypes.any,
  permissions: PropTypes.any,
  bankDetails: PropTypes.any,
  userId: PropTypes.string.isRequired,
  updateBankDetails: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
};

export default LegalEntityModal;
